import { createAction } from '@reduxjs/toolkit';

export const noneAction = createAction('none');
